var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgTanzanite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.9149 43.8039L59.07 24.5208C58.8509 22.2023 57.8189 20.0323 56.1648 18.3924L39.1296 1.49852C37.108 -0.508948 33.8423 -0.508948 31.8136 1.49852L14.7784 18.3924C13.1243 20.0323 12.0994 22.2023 11.8732 24.5208L10.0425 43.8039C9.74557 46.9282 10.9331 50.0101 13.2516 52.1236L30.9937 68.2611C33.5384 70.5725 37.4261 70.5725 39.9637 68.2611L57.6987 52.1165C60.0243 50.0101 61.2118 46.9282 60.9149 43.8039Z",
    fill: "#536DFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7925 18.3995C14.0362 19.1487 13.4212 20.004 12.9476 20.9371H35.4822V1.97213C35.4822 0.827022 34.3018 0.0424116 33.2627 0.501868C33.2344 0.516005 33.1991 0.530143 33.1708 0.54428C32.9517 0.650308 32.7396 0.777542 32.5417 0.918914C32.4993 0.947188 32.4639 0.975462 32.4215 1.00374C32.2165 1.15924 32.0116 1.32182 31.8207 1.5056L26.2789 7.00495L15.0258 18.1662L14.7925 18.3995Z",
    fill: "#6E94FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3251 64.9248L30.9937 68.2612C33.5383 70.5726 37.4261 70.5726 39.9637 68.2612L43.6323 64.9248H27.3251Z",
    fill: "#4958EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9846 48.766L33.2274 68.6852C33.708 69.4698 34.5492 69.9929 35.461 69.9929C35.4681 69.9929 35.4822 69.9929 35.4893 69.9929C36.4082 69.9929 37.2423 69.4627 37.723 68.6852L49.9657 48.766H20.9846Z",
    fill: "#6E94FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4822 20.9371L20.9846 48.7661H49.9799L35.4822 20.9371Z",
    fill: "#DCEFFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9798 48.7661L58.1652 22.7255C58.349 22.1317 58.2995 21.4885 58.0168 20.9371H35.4822L49.9798 48.7661Z",
    fill: "#6E94FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.679 22.365L20.9775 48.7661L35.4752 20.9371H12.9476L12.778 21.2694C12.6013 21.6086 12.5659 22.0045 12.679 22.365Z",
    fill: "#9CC9FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1438 23.6868C22.7941 22.4357 21.8893 20.9371 20.4756 20.9371H16.5879H12.9476C12.6649 21.4885 12.6083 22.1317 12.7992 22.7255L15.2732 30.6069C15.7256 32.0489 17.6977 32.2256 18.3975 30.8826L22.1438 23.6868Z",
    fill: "#C5E2FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0443 69.8091C38.1046 69.5546 39.1154 69.0457 39.9707 68.2682L57.7057 52.1236C58.2288 51.65 58.6883 51.1269 59.0841 50.5614C59.6142 49.8121 59.0417 48.766 58.1157 48.766H49.9727L37.0443 69.8091Z",
    fill: "#4553DB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2587 52.1235L30.9937 68.2611C31.849 69.0386 32.8598 69.5476 33.9201 69.802L20.9847 48.7589H12.8417C11.9228 48.7589 11.3431 49.798 11.8733 50.5543C12.2762 51.1198 12.7356 51.65 13.2587 52.1235Z",
    fill: "#4553DB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.179 12.2145L44.9116 17.8977C46.0355 19.0145 45.2439 20.9301 43.6605 20.9301H39.5254H35.4822V12.8012C35.4822 11.2249 37.3836 10.4333 38.5075 11.543L39.179 12.2145Z",
    fill: "#4553DB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTanzanite);
export default __webpack_public_path__ + "static/media/tanzanite.72ed062f.svg";
export { ForwardRef as ReactComponent };